export default {"src":"/evde-internet/_next/static/media/mobile-confeti.7ea403f7.svg","height":150,"width":104};